import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReactGA from "react-ga4";
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import SeoHelmet from "../components/SeoHelmet";
import chrome from "../static/chrome.png";
import firefox from "../static/firefox.png";
import edge from "../static/edge.png";
import opera from "../static/opera.png";
import autoTabOpenerIcon from "../static/auto_tab_opener.png";
import "./ToolDetail.css";

const browsers = [
    {
        name: "Chrome",
        image: chrome,
        url: "https://chrome.google.com/webstore/detail/automatic-tab-opener/hkjobkeceflhccchhjkfofhbcaaaccag?utm_source=instanceof",
    },
    {
        name: "Firefox",
        image: firefox,
        url: "https://addons.mozilla.org/en-US/firefox/addon/automatic-tab-opener?utm_source=instanceof",
    },
    {
        name: "Edge",
        image: edge,
        url: "https://microsoftedge.microsoft.com/addons/detail/automatic-tab-opener/dhabkgfndffndlhihfpijpcfbdpiibgd?utm_source=instanceof",
    },
    {
        name: "Opera",
        image: opera,
        url: "https://addons.opera.com/pt/extensions/details/automatic-tab-opener?utm_source=instanceof",
    },
];

const AutoTabOpener = () => {
    const trackBrowserClick = (browser) => {
        ReactGA.event({
            category: "AutoTabOpener",
            action: `User pressed ${browser}`,
        });
    };

    return (
        <div className="Container">
            <SeoHelmet
                title="InstanceOf | Automatic Tab Opener"
                description="Schedule multiple URLs to open automatically using a cron expression or a preset interval."
            />
            <Navbar />

            <main className="Centered-Content ToolDetail-content">
                <section className="ToolDetail-hero">
                    <img
                        className="ToolDetail-icon"
                        src={autoTabOpenerIcon}
                        alt="Automatic Tab Opener extension icon"
                    />
                    <div className="ToolDetail-hero-copy">
                        <Typography
                            component="h1"
                            variant="h3"
                            className="ToolDetail-title"
                        >
                            Automatic Tab Opener
                        </Typography>
                        <Typography
                            component="p"
                            variant="h6"
                            className="ToolDetail-lead"
                        >
                            Open the URLs you need, on a schedule.
                        </Typography>
                        <Typography
                            component="p"
                            variant="body1"
                            className="ToolDetail-description"
                        >
                            Set a list of URLs and choose when the extension
                            should open them, using a cron schedule or a
                            predefined interval.
                        </Typography>
                    </div>
                </section>

                <section className="ToolDetail-section">
                    <Typography
                        component="h2"
                        variant="h5"
                        className="ToolDetail-section-title"
                    >
                        Set a schedule
                    </Typography>
                    <div className="ToolDetail-feature-grid">
                        <Card className="ToolDetail-feature">
                            <CardContent>
                                <Typography
                                    component="h3"
                                    variant="h6"
                                    className="ToolDetail-feature-title"
                                >
                                    Choose your URLs
                                </Typography>
                                <Typography
                                    component="p"
                                    variant="body2"
                                    className="ToolDetail-feature-copy"
                                >
                                    Add the pages you want the extension to
                                    open.
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card className="ToolDetail-feature">
                            <CardContent>
                                <Typography
                                    component="h3"
                                    variant="h6"
                                    className="ToolDetail-feature-title"
                                >
                                    Pick a timing
                                </Typography>
                                <Typography
                                    component="p"
                                    variant="body2"
                                    className="ToolDetail-feature-copy"
                                >
                                    Use a preset such as hourly, or specify a
                                    cron expression.
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                    <div className="ToolDetail-example">
                        <Typography
                            component="p"
                            variant="body2"
                            className="ToolDetail-example-copy"
                        >
                            For example, to open your URLs every day at 8am,
                            use:
                        </Typography>
                        <code className="ToolDetail-code">0 8 * * *</code>
                    </div>
                </section>

                <section className="ToolDetail-section">
                    <Typography
                        component="h2"
                        variant="h5"
                        className="ToolDetail-section-title"
                    >
                        Get the extension
                    </Typography>
                    <div className="ToolDetail-store-grid">
                        {browsers.map((browser) => (
                            <Card
                                className="ToolDetail-store-card"
                                key={browser.name}
                            >
                                <CardActionArea
                                    component="a"
                                    href={browser.url}
                                    className="ToolDetail-store-action"
                                    onClick={() =>
                                        trackBrowserClick(browser.name)
                                    }
                                >
                                    <img
                                        className="ToolDetail-store-icon"
                                        src={browser.image}
                                        alt=""
                                    />
                                    <Typography
                                        component="span"
                                        variant="h6"
                                        className="ToolDetail-store-name"
                                    >
                                        {browser.name}
                                    </Typography>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        className="ToolDetail-store-link"
                                    >
                                        View in store
                                    </Typography>
                                </CardActionArea>
                            </Card>
                        ))}
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default AutoTabOpener;
